<template>
<div>

  <v-dialog
    scrollable
    v-model="isShowDialog"
    fullscreen
    hide-overlay
    transition="dialog-bottom-transition"
    :persistent="true"
  >
    <v-app-bar
      dark
      color="black"
      fixed
      dense
    >
      <v-toolbar-title>

        <v-breadcrumbs
          class="pl-3"
          :items="breadcrumbs"
          large
        >
          <template v-slot:divider>
            <v-icon>mdi-chevron-right</v-icon>
          </template>
          <template v-slot:item="{ item }">
            <v-breadcrumbs-item
              v-if="item.name === '檢視專案'"
              @click.prevent="viewProject"
              :href="item.href"
              :disabled="item.disabled"
            >
              {{ item.text }}
            </v-breadcrumbs-item>

            <v-breadcrumbs-item
              v-else
              @click.prevent="$router.push({'name': item.name})"
              :href="item.href"
              :disabled="item.disabled"
            >
              {{ item.text }}
            </v-breadcrumbs-item>
          </template>
        </v-breadcrumbs>

        <!-- {{formTitle}} -->
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn
        icon
        dark
        @click="close"
      >
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-app-bar>
    <v-card
      style="padding-top: 96px !important;overflow-y:auto;">
      <v-card-text>
        <v-form
          ref="form"
          v-model="isFormValid"
          :lazy-validation="true"
        >
          <v-container>
            <v-subheader class="pl-0 text--primary title">基本資料</v-subheader>
            <!-- 名稱編號 -->
            <v-row>
              <v-col
                cols="12"
                sm="6"
                md="4"
              >
                <v-text-field
                  v-model="form.Name"
                  label="專案名稱"
                  :rules="formRules.name"
                  list="datalist-project-in__project-editor"
                >
                  <template v-slot:append>
                    <datalist id="datalist-project-in__project-editor">
                      <option
                        v-for="project in projects"
                        :key="`project-datalist-${project.ID}`"
                      >{{project.Name}}</option>
                    </datalist>
                  </template>
                </v-text-field>
              </v-col>
              <v-col
                cols="12"
                sm="6"
                md="4"
              >
                <v-autocomplete
                  :items="managerOptions"
                  item-text="Name"
                  item-value="ID"
                  label="負責人"
                  v-model="form.ManagerID"
                  :rules="formRules.manager"
                ></v-autocomplete>
              </v-col>
            </v-row>
            <v-row>
              <v-col
                cols="12"
                sm="6"
                md="4"
              >
                <v-select
                  :items="projectSourceOptions"
                  item-text="Name"
                  item-value="Name"
                  label="案源"
                  v-model="form.Source"
                  :rules="formRules.source"
                ></v-select>
              </v-col>
              <v-col
                cols="12"
                sm="6"
                md="4"
              >
                <v-text-field
                  v-if="form.ID"
                  v-model="form.ID"
                  label="案號"
                  :readonly="true"
                ></v-text-field>
                <v-text-field
                  v-else
                  value="系統自動產生"
                  label="案號"
                  :readonly="true"
                ></v-text-field>
              </v-col>
            </v-row>
            <!-- 金額、狀態資訊 -->
            <v-row>
              <v-col
                cols="12"
                sm="6"
                md="4"
              >
                <v-select
                  :items="projectStatusOptions"
                  :item-disabled="checkStatusDisabled"
                  item-text="Name"
                  item-value="Name"
                  label="狀態"
                  v-model="form.Status"
                ></v-select>
              </v-col>
              <v-col
                cols="12"
                sm="6"
                md="4"
              >
                <v-text-field
                  v-model="form.Amount"
                  label="金額"
                  type="number"
                  step="1"
                  min="0"
                  max="1000000000"
                  :rules="formRules.Amount"
                ></v-text-field>
              </v-col>
              <v-col
                cols="12"
                sm="6"
                md="4"
              >
                <v-text-field
                  v-model="form.FinalAmount"
                  @input="onFinalAmountChanged"
                  label="議價後金額"
                  type="number"
                  step="1"
                  min="0"
                  max="1000000000"
                  :rules="formRules.FinalAmount"
                ></v-text-field>
              </v-col>
            </v-row>
            <!-- 客戶 -->
            <v-row>
              <v-col
                cols="12"
                sm="6"
                md="4"
              >
                <v-autocomplete
                  :items="countyList"
                  item-text="Name"
                  item-value="ID"
                  label="地區"
                  v-model="form.CountyID"
                ></v-autocomplete>
              </v-col>
              <v-col
                cols="10"
                sm="4"
                md="3"
              >
                <v-autocomplete
                  :items="clientList"
                  :item-text="clientSelectLabel"
                  item-value="ID"
                  label="客戶"
                  v-model="form.ClientID"
                ></v-autocomplete>
              </v-col>
              <v-col
                cols="2"
                sm="2"
                md="1"
              >
                <v-btn
                  color="primary"
                  class="mt-2"
                  fab
                  dark
                  small
                  @click.stop="isShowClientCreatorDialog = true"
                >
                  <v-icon>mdi-plus</v-icon>
                </v-btn>
              </v-col>
              <v-col
                cols="12"
                sm="6"
                md="4"
              >
                <v-text-field
                  v-model="form.ClientDepartment"
                  label="科室"
                ></v-text-field>
              </v-col>
              <v-col
                cols="12"
                sm="12"
                md="12"
              >
                <v-textarea
                  v-model="form.ClientContact"
                  rows="3"
                  label="聯繫窗口"
                ></v-textarea>
              </v-col>
              <v-col
                cols="12"
                sm="12"
                md="12"
              >
                <v-textarea
                  v-model="form.Description"
                  rows="3"
                  label="其他說明"
                ></v-textarea>
              </v-col>
            </v-row>

            <v-subheader class="pl-0 text--primary title">結案紀錄</v-subheader>
            <v-row>
              <v-col
                cols="12"
                sm="12"
                md="12"
              >
                <v-text-field
                  v-model="form.CloseRecord"
                  label="結案存檔路徑"
                  :rules="formRules.CloseRecord"
                ></v-text-field>
              </v-col>
              <v-col
                cols="12"
                sm="12"
                md="12"
              >
                <v-textarea
                  v-model="form.ReviewNote"
                  rows="3"
                  label="檢討與說明"
                ></v-textarea>
              </v-col>
            </v-row>
          </v-container>
        </v-form>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="blue darken-1"
          text
          @click="save"
        >Save</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>

  <client-addedit-dialog
      v-model="isShowClientCreatorDialog"
      :editing-id="-1"
      @updated="client=>{form.ClientID = client.ID}"
  />

  <v-dialog
      scrollable
      v-model="isLoading"
      fullscreen
  >
      <v-container
      fluid
      fill-height
      style="background-color: rgba(0, 0, 0, 0.5);"
      >
      <v-layout
          justify-center
          align-center
      >
          <v-progress-circular
          indeterminate
          color="white"
          ></v-progress-circular>
      </v-layout>
      </v-container>
  </v-dialog>
</div>
</template>


<script>
import { mapGetters } from "vuex";
import ClientAddeditDialog from "@/ui/management/client/client-addedit-dialog.vue";
import redirectMixin from "@/ui/mixin-redirect.vue";
import AppDataSetting from '@/data/app-data-setting.js'
export default {
  mixins: [redirectMixin],
  components: {
    ClientAddeditDialog
  },
  props: {
    value: {
      type: Boolean,
      required: true,
      default: false
    },
    id: {
      required: true
    }
  },
  data: () => ({
    isLoading: false,
    isFormValid: false,
    form: {
      Name: "",
      ClientContact: "姓名: \n電話: \nEmail: \n",
      Status: "招標中"
    },
    defaultItem: {
      Name: "",
      ClientContact: "姓名: \n電話: \nEmail: \n",
      Status: "招標中"
    },
    projectSourceOptions: [{ Name: "SH" }, { Name: "BU" }, { Name: "IC" }],
    projectStatusOptions: [
      { Name: "招標中" },
      { Name: "未得標" },
      { Name: "執行中" },
      { Name: "已結案" },
      { Name: "已完成" }
    ],
    // 新增客戶
    isShowClientCreatorDialog: false
  }),
  computed: {
    isShowDialog: {
      set(val) {
        this.$emit("input", val);
      },
      get() {
        return this.value;
      }
    },
    formRules() {
      const FinalAmountValidation = v => {
        return this.form.Status == "執行中"
          ? v > 0
            ? true
            : "請輸入議價後金額"
          : true;
      };
      const CloseRecordValidation = v => {
        return this.form.Status == "已結案"
          ? (this.form.CloseRecord)
            ? true
            : "結案時，請務必輸入存擋路徑"
          : true;
      };
      return {
        name: [v => !!v || "請輸入名稱"],
        manager: [v => !!v || "請選擇負責人"],
        source: [v => !!v || "請選擇案源"],
        FinalAmount: [
          FinalAmountValidation,
          v => parseInt(v) || 0 <= 1000000000 || "議價後金額不可超過10億"
        ],
        Amount: [v => parseInt(v) || 0 <= 1000000000 || "金額不可超過10億"],
        CloseRecord: [
          CloseRecordValidation
        ]
      };
    },
    breadcrumbs() {
      let objs = [
        {
          text: "專案管理",
          disabled: false,
          href: "../project",
          name: "project-list"
        },
        {
          text: this.formTitle,
          disabled: true,
          href: ""
        }
      ];
      if (this.isEdit) {
        objs.splice(1, 0, {
          name:'檢視專案',
          text: this.form.Name,
          disabled: false,
          href: "javascript:;"
        })
      }
      return objs
    },
    editingId () {
      return this.$store.state.UI.dialog.projectEditor.id
    },
    isEdit() {
      return this.$store.state.UI.dialog.projectEditor.id  > 0
    },
    formTitle() {
      return !this.isEdit ? "新增專案" : "編輯專案";
    },
    clientList() {
      if (this.form.ClientID > 0) {
        var idx = this.activeClientList.findIndex(
          o => o.ID === this.form.ClientID
        );
        if (idx < 0) {
          var inactiveClient = this.$store.state.client.list.find(
            o => o.ID === this.form.ClientID
          );
          if (inactiveClient) {
            return [inactiveClient].concat(this.activeClientList);
          }
        }
      }
      return this.activeClientList;
    },
    countyList() {
      if (this.form.CountyID > 0) {
        var idx = this.activeCountyList.findIndex(
          o => o.ID === this.form.CountyID
        );
        if (idx < 0) {
          var inactiveCounty = this.$store.state.county.list.find(
            o => o.ID === this.form.CountyID
          );
          if (inactiveCounty) {
            return [inactiveCounty].concat(this.activeCountyList);
          }
        }
      }
      return this.activeCountyList;
    },
    editingIdx() {
      return this.$store.state.project.list.findIndex(
        o => o.ID == this.editingId
      );
    },
    managerOptions() {
      const genNamePrefix = user => {
        let level = AppDataSetting.findUserLevel(this, user)
        var prefix = ''
        if (level==1000) prefix = `(總經理) `
        else if (level==10) prefix = `(主管) `
        return prefix
      }
      var options = this.activeUsers
        .filter(o => AppDataSetting.findUserLevel(this, o) <= 10 || AppDataSetting.findUserLevel(this, o) == 1000)
      options.sort((o1,o2)=>AppDataSetting.findUserLevel(this,o2)-AppDataSetting.findUserLevel(this,o1))
      return options.map(o => ({ ID: o.ID, Name: genNamePrefix(o)+o.Profile.Name }));
    },
    ...mapGetters([
      "activeCountyList",
      "activeClientList",
      "userPositions",
      "userDepartments",
      "activeUsers",
      "myLevel",
      "countries",
      "projects"
    ])
  },
  methods: {
    onFinalAmountChanged() {
      if (this.form.FinalAmount > 0 && this.form.Status == "招標中")
        this.form.Status = "執行中";
    },
    clientSelectLabel(client) {
      let clientCountyName = (
        this.countries.find(o => o.ID === client.CountyID) || {}
      ).Name;
      return (clientCountyName || "") + client.Name;
    },
    checkStatusDisabled(item) {
      return (
        item.Name == "已完成" &&
        (!this.form.CloseSignerIDs || !this.form.CloseSignerIDs.length)
      );
    },
    save() {
      if (!this.$refs.form.validate()) return;

      this.form.Amount = parseInt(this.form.Amount) || 0;
      this.form.FinalAmount = parseInt(this.form.FinalAmount) || 0;

      if (this.form.Amount > 1000000000) {
        return alert("金額不可大於10億");
      }
      if (this.form.FinalAmount > 1000000000) {
        return alert("議價後金額不可大於10億");
      }

      this.isLoading = true;
      if (this.editingId > 0) {
        if (this.editingIdx < 0) {
          this.isLoading = false;
          return alert("發生異常：無法找到編輯物件");
        }
        this.$services.project
          .edit(this, this.form)
          .then(res => {
            this.$set(
              this.$store.state.project.list,
              this.editingIdx,
              res.data.result
            );
            // this.$router.push({ name: "project-list" });
            this.$emit("updated", res.data.result);
            this.close();
          })
          .finally(() => {
            this.isLoading = false;
          });
      } else {
        this.$services.project
          .add(this, this.form)
          .then(res => {
            this.$services.todoItem.prepareData(this)
            this.$store.state.project.list.splice(0, 0, res.data.result);
            this.$emit("updated", res.data.result);
            this.close();
            // if (
            //   this.myLevel >= 1000 &&
            //   window.confirm("專案建立成功!\n是否馬上分配專案預算?")
            // ) {
            //   this.redirectToProjectTaskTab(res.data.result.ID);
            // }
          })
          .finally(() => {
            this.isLoading = false;
          });
      }
    },
    close() {
      this.$emit("close");
    },
    viewProject() {
      this.redirectToProject(this.form.ID)
      this.close()
    },
    init() {
      this.isLoading = true;
      var promiseList = [
        this.$services.client.prepareData(this),
        this.$services.county.prepareData(this)
      ];
      var prepareProejctPromise = this.$services.project.prepareData(this);
      promiseList.push(prepareProejctPromise);

      if (this.isEdit) {
        prepareProejctPromise.then(() => {
          if (this.editingIdx > -1) {
            var project = this.$store.state.project.list[this.editingIdx];
            this.form = JSON.parse(JSON.stringify(project));
          } else {
            alert("錯誤 找不到該專案");
          }
        });
      } else {
        this.form = JSON.parse(JSON.stringify(this.defaultItem));
      }
      if (this.$refs.form) this.$refs.form.resetValidation();
      Promise.all(promiseList).finally(() => {
        this.isLoading = false;
      });
    }
  },
  watch: {
    isShowDialog(val) {
      if (val) {
        this.init()
      }
    }
  }
};
</script>